import React from "react";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

const AddProjectInstitution = ({Institutions, handleAdd}) => {
    const [open, setOpen] = React.useState(false);
    const [institution, setInstitution] = React.useState(0);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setInstitution(0);
        setOpen(false);
    };

    const handleCreate = () => {
        if (institution !== 0) {
            setOpen(false);
            handleAdd(institution);
        } else {
            toaster('error', 'Please Select Institution');
        }
    };

    const handleChange = ({ target }) => {
        if (target.name === "institution") {
            setInstitution(parseInt(target.value));
        }
    };

    return (
        <React.Fragment>
            <div className="float-right">
                <button
                    className="btn btn-outline-blue rounded-0"
                    onClick={handleClickOpen}
                >
                    + New Institution
                </button>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Add Project Institution</DialogTitle>
                <DialogContent>
                    <div className="form-group">
                        <label htmlFor="newUser" className="small">
                            Institution
                        </label>
                        <select
                            name="institution"
                            id="newInstitution"
                            className="form-control"
                            onChange={handleChange}
                            value={institution}
                        >
                            <option key="-1">- Select -</option>
                            {Institutions.map((institution) => (
                                <option value={institution.Institution_ID} key={"userOpt" + institution.Institution_ID}>
                                    {institution.Institution_Name}
                                </option>
                            ))}
                        </select>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleCreate} color="primary">
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer/>
        </React.Fragment>
    );
}

export default AddProjectInstitution;